import INFTCollections from '../../models/INFTCollections'
import SporeCard from '../../nftFormats/Spore/Card/SporeCard'
import SporeDetail from '../../nftFormats/Spore/Detail/SporeDetail'
import SporeActivtyDetail from '../../nftFormats/Spore/Activity/SporeActivtyDetail'
import SporeLogo from '../../../../assets/nft-logo/SporeLogo.jpg'

export const SporeData: INFTCollections[] = [
  {
    id: 'SporeNFTV1',
    tokenAddress: '0xc2457f6eb241c891ef74e02ccd50e5459c2e28ea',
    name: 'Spore NFT',
    cardFormat: SporeCard,
    detailFormat: SporeDetail,
    activityFormat: SporeActivtyDetail,
    category: 4,
    creatorAddress: '0x88dd784dfaab1a7752d2cc81071fcd12c1c4e1db',
    logo: SporeLogo,
    website: 'https://spore.earth/nft',
    twitter: 'sporeproject',
    telegram: 'https://t.me/sporefinanceofficial',
    discord: 'https://discord.com/invite/hYDnmyadJC'
  }
]

export const SporeCategoryData = {
  [SporeData[0].tokenAddress.toLowerCase()]: SporeData[0].category
}